export interface PairingResult {
  alcoholic: string;
  nonAlcoholic: string;
}

const alcoholicPairings: Record<string, string> = {
  smoky: "Peated Scotch",
  earthy: "Dark Rum",
  citrus: "Gin & Tonic",
  sweet: "Port Wine",
  spicy: "Bourbon",
  coffee: "Irish Coffee",
  pepper: "Rye Whiskey",
  leather: "Cognac",
  cocoa: "Dark Rum",
  cream: "Irish Cream",
  cedar: "Single Malt Scotch",
  nut: "Brandy",
  vanilla: "Bourbon",
};

const nonAlcoholicPairings: Record<string, string> = {
  smoky: "Black Coffee",
  earthy: "Espresso",
  citrus: "Iced Tea",
  sweet: "Hot Chocolate",
  spicy: "Chai Tea",
  coffee: "Cold Brew",
  pepper: "Ginger Tea",
  leather: "Dark Coffee",
  cocoa: "Hot Chocolate",
  cream: "Vanilla Latte",
  cedar: "Green Tea",
  nut: "Hazelnut Coffee",
  vanilla: "Vanilla Milk",
};

export function getPairing(flavorTags: string[]): PairingResult {
  const mainFlavor = flavorTags[0] || "smoky";
  
  return {
    alcoholic: alcoholicPairings[mainFlavor] ?? "Whiskey",
    nonAlcoholic: nonAlcoholicPairings[mainFlavor] ?? "Espresso",
  };
}

